import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import { HisAuthService, HisNotificationService, HisUiService } from 'hisng';
import { PublicationModuleOptions } from '../../../publication-module.options';

@Component( {
    selector: 'res-publication-search-form',
    templateUrl: './publication-search-form.component.html'
} )
export class PublicationSearchFormComponent implements OnInit {
    public readonly moduleOptions = PublicationModuleOptions;

    constructor(
        public auth: HisAuthService,
        private location: Location,
        private route: ActivatedRoute,
        private notificationService: HisNotificationService,
        private hisUiService: HisUiService
    ) { }

    ngOnInit() {
        this.route.queryParams.subscribe( (queryParams: Params) => {
            // delete success message
            if ( queryParams.deleteSuccess && parseInt( queryParams.deleteSuccess, 10 ) === 1 ) {
                this.notificationService.deleteSuccessI18nRes();
            }
            // save for validation success message
            if ( queryParams.saveForValidationSuccess && parseInt( queryParams.saveForValidationSuccess, 10 ) === 1 ) {
                this.notificationService.successI18nRes( 'fs.res.publication.success.create' );
            }
            this.location.replaceState( 'pub/search' );
        } );
    }
}
